import { useState } from 'react';

import { BaseField, BaseFieldProps } from "@king-ict/eupisi-ui/components/BaseField";
import ReactQuill from 'react-quill';
import "react-quill/dist/quill.snow.css";

const QuillModules = {
    toolbar: [
        [{ size: [] }],
        ["bold", "italic", "underline"],
        [{ list: "bullet" }, { list: "ordered" }],
        ['link'],
    ],
};

export interface TextEditorV2Props extends BaseFieldProps {
    label?: string;
    handleChange: (value: string) => void;
    placeholder?: string;
    plaintext?: boolean;
    initialValue?: string;
}

export const TextEditorV2 = ({
    label,
    handleChange,
    placeholder,
    required,
    helperText,
    errorText,
    infoText,
    boldLabel,
    smallLabel,
    plaintext,
    initialValue
}: TextEditorV2Props) => {
        
    const [value, setValue] = useState(initialValue || "");


    function onInputChange(v: any) {
        setValue(v);
        handleChange(v);
    }


    return (
        <BaseField
            label={label}
            helperText={helperText}
            errorText={errorText}
            infoText={infoText}
            boldLabel={boldLabel}
            required={required}
            smallLabel={smallLabel}
        >
            {plaintext ? (
                <div style={{ border: '1px solid #d5d5d5', padding: '4px' }} dangerouslySetInnerHTML={{ __html: value }}></div>
            ) : (
                <ReactQuill
                    placeholder={placeholder}
                    theme="snow"
                    value={value}
                    modules={QuillModules}
                    onChange={onInputChange}
                    style={{ height: "90%", borderRadius: "20px " }}
                />
            )}
        </BaseField>
    );
};